import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const DeparturesIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            d='M22.08 9.248c.096.4.04.776-.168 1.128a1.485 1.485 0 0 1-.912.696l-9.648 2.592-5.304 1.392-1.584.48-2.64-4.488 1.464-.384 1.968 1.488 4.968-1.296L6.096 3.68l1.92-.528 6.888 6.432 5.352-1.416c.4-.112.78-.06 1.14.156.36.216.588.524.684.924zM2.496 18.584h19.032V20.6H2.496v-2.016z'
        />
    ),
})

DeparturesIcon.displayName = 'DeparturesIcon'
